// src/components/report/Header.js
import React from 'react';

const Header = ({ customerName, membershipDuration }) => (
  <div className="bg-white rounded-xl p-8 shadow-lg mb-6"> {/* Increased padding */}
    <div className="text-center mb-8"> {/* Increased bottom margin */}
      <img 
        src="https://wealth.taiseer.co/assets/logos/Taiseer-New-Logo-04.svg" 
        alt="Taiseer" 
        className="h-24 md:h-28 mx-auto mb-8" /* Significantly larger, with responsive sizing */
      />
    </div>
    <div className="text-center">
      <h1 className="text-2xl md:text-3xl font-bold text-[#234363] mb-3">{customerName}</h1>
      <p className="text-gray-600 text-lg">
        مع تيسير من {membershipDuration.years} سنة و {membershipDuration.months} شهر
      </p>
    </div>
  </div>
);

export default Header;